<template>
	<div class="wrapper">
		<side-bar>

			<sidebar-link to="/dashboard">
				<md-icon>card_giftcard</md-icon>
				<p>កញ្ចប់ឥវ៉ាន់</p>
			</sidebar-link>
			<sidebar-link to="/scan">
				<md-icon>qr_code_scanner</md-icon>
				<p>ស្កេនបើកកញ្ចប់ឥវ៉ាន់</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>ផ្លាស់ប្តូរពាក្យសំងាត់</p>
			</sidebar-link>
			<sidebar-link to="/logout">
				<md-icon>logout</md-icon>
				<p>ចាកចេញ</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue